import React from "react";
import FotoPerformance from "../components/FotoPerformance";

export default function Test() {
  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "0 20px" }}>
      <FotoPerformance imageKey="Lorenza2" />
    </div>
  );
}
